import { CopyCircleOutlined } from '@easyv/react-icons';
import { copyToClipBoard } from '@/utils';
import { message } from '@easyv/react-components';
import * as React from 'react';

interface CopyIdNodeProps {
  id: string;
}

export function CopyIdNode(props: CopyIdNodeProps) {
  const { id } = props;

  return (
    <div
      className='text-baseText cursor-pointer group'
      onClick={async () => {
        try {
          await copyToClipBoard(id);
          message.success('已复制');
        } catch (error) {
          message.error((error as Error).message);
        }
      }}
    >
      <CopyCircleOutlined className='group-hover:text-white' size={14} />
    </div>
  );
}
